import angular from 'angular'

// components
import emptyState from './component/emptyState.js'

export default angular
  .module('portalApp.emptyState', [])
  .component('emptyState', emptyState).name
